export default __webpack_public_path__ + "static/media/1940.f7fd7292.png";